// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_btn__b3ysZ {
  outline: none;
  border-radius: 7px;
  border: none;
  padding: 10px 25px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  white-space: nowrap;
}
/* sss */
.button_btn__b3ysZ.button_primary__63x0c {
  background-color: var(--primary-color);
  color: var(--white-color);
  font-weight: 700;
}

.button_btn__b3ysZ.button_primary__63x0c:hover {
  background-color: var(--button-hover);
}

.button_btn__b3ysZ.button_primaryBorder__qCOLi {
  background-color: var(--white-color);
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
  font-weight: 700;
}

.button_btn__b3ysZ.button_primaryBorder__qCOLi:hover {
  color: var(--red-color);
  border: 2px solid var(--red-color);
}

.button_btn__b3ysZ.button_textGray__R\\+SmA svg {
  padding-right: 4px;
}
.button_btn__b3ysZ svg {
  padding-right: 4px;
}
.button_btn__b3ysZ.button_white__dPfC3 {
  background-color: var(--white-color);
  color: var(--text-color-v1);
}

.button_btn__b3ysZ.button_white__dPfC3:hover {
  background-color: var(--hover-green);
}

.button_btn__b3ysZ.button_white-v2__2Bit\\+ {
  background-color: var(--white-color);
  color: var(--text-color-v1);
}

.button_btn__b3ysZ.button_white-v2__2Bit\\+:hover {
  color: var(--primary-color);
}

.button_btn__b3ysZ.button_textGray__R\\+SmA {
  background-color: var(--white-color);
  color: var(--text-color-v2);
  padding: 10px 15px;
  font-weight: 500;
  min-width: 130px;
}

.button_btn__b3ysZ.button_textRed__Tg2hU {
  width: fit-content;
  background-color: var(--white-color);
  color: var(--red-color);
  padding: 5px 25px;
  font-weight: 500;
}
.button_btn__b3ysZ.button_borderRed__r6y7e {
  color: var(--red-color);
  border: 2px solid var(--red-color);
  padding: 10px 7px;
  background-color: transparent;
}
.button_btn__b3ysZ.button_borderRed__r6y7e:hover {
  color: var(--white-color);
  background: var(--red-color);
}
.button_disabled__vxFQC {
  /* background-color: var(--text-color) !important; */
  cursor: no-drop;
}

.button_spinnerBorder__\\+kS5s {
  width: 16px !important;
  height: 16px !important;
  border-width: 1px !important;
  margin-right: 10px;
}

@media only screen and (max-width: 480px) {
  /* .btn.primary {
    font-size: 16px;
    width: fit-content;
    height: 100% !important;
    padding: 10px 20px;
  } */
}
`, "",{"version":3,"sources":["webpack://./src/Components/atoms/Button/button.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA,QAAQ;AACR;EACE,sCAAsC;EACtC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE;;;;;KAKG;AACL","sourcesContent":[".btn {\n  outline: none;\n  border-radius: 7px;\n  border: none;\n  padding: 10px 25px;\n  line-height: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  white-space: nowrap;\n}\n/* sss */\n.btn.primary {\n  background-color: var(--primary-color);\n  color: var(--white-color);\n  font-weight: 700;\n}\n\n.btn.primary:hover {\n  background-color: var(--button-hover);\n}\n\n.btn.primaryBorder {\n  background-color: var(--white-color);\n  color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n  font-weight: 700;\n}\n\n.btn.primaryBorder:hover {\n  color: var(--red-color);\n  border: 2px solid var(--red-color);\n}\n\n.btn.textGray svg {\n  padding-right: 4px;\n}\n.btn svg {\n  padding-right: 4px;\n}\n.btn.white {\n  background-color: var(--white-color);\n  color: var(--text-color-v1);\n}\n\n.btn.white:hover {\n  background-color: var(--hover-green);\n}\n\n.btn.white-v2 {\n  background-color: var(--white-color);\n  color: var(--text-color-v1);\n}\n\n.btn.white-v2:hover {\n  color: var(--primary-color);\n}\n\n.btn.textGray {\n  background-color: var(--white-color);\n  color: var(--text-color-v2);\n  padding: 10px 15px;\n  font-weight: 500;\n  min-width: 130px;\n}\n\n.btn.textRed {\n  width: fit-content;\n  background-color: var(--white-color);\n  color: var(--red-color);\n  padding: 5px 25px;\n  font-weight: 500;\n}\n.btn.borderRed {\n  color: var(--red-color);\n  border: 2px solid var(--red-color);\n  padding: 10px 7px;\n  background-color: transparent;\n}\n.btn.borderRed:hover {\n  color: var(--white-color);\n  background: var(--red-color);\n}\n.disabled {\n  /* background-color: var(--text-color) !important; */\n  cursor: no-drop;\n}\n\n.spinnerBorder {\n  width: 16px !important;\n  height: 16px !important;\n  border-width: 1px !important;\n  margin-right: 10px;\n}\n\n@media only screen and (max-width: 480px) {\n  /* .btn.primary {\n    font-size: 16px;\n    width: fit-content;\n    height: 100% !important;\n    padding: 10px 20px;\n  } */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `button_btn__b3ysZ`,
	"primary": `button_primary__63x0c`,
	"primaryBorder": `button_primaryBorder__qCOLi`,
	"textGray": `button_textGray__R+SmA`,
	"white": `button_white__dPfC3`,
	"white-v2": `button_white-v2__2Bit+`,
	"textRed": `button_textRed__Tg2hU`,
	"borderRed": `button_borderRed__r6y7e`,
	"disabled": `button_disabled__vxFQC`,
	"spinnerBorder": `button_spinnerBorder__+kS5s`
};
export default ___CSS_LOADER_EXPORT___;
